export default __webpack_public_path__ + "static/media/ferry-station.3ecf37a2.svg";